import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function DemoLogin() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("demo@contactassist.app");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/demo-login", { email, password });
      toast.success("Signed in as demo teacher");
      await refresh();
      nav("/dashboard", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invalid demo credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="h-8 w-8 rounded-md bg-[#971a8c] text-white flex items-center justify-center">
            <Mail className="h-4 w-4" />
          </div>
          <span className="font-heading text-lg text-[#1C2321]">ContactAssist</span>
        </div>

        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#8B9891] mb-3">Tester access</p>
        <h1 className="font-heading text-3xl tracking-tight text-[#1C2321] font-medium mb-2">Demo login</h1>
        <p className="text-sm text-[#5D6D63] mb-8">
          Signs into a preconfigured account with sample parent emails already logged. No Gmail connection needed. Perfect for showing the app in a demo.
        </p>

        <label className="text-xs uppercase tracking-[0.2em] font-semibold text-[#8B9891] block mb-2">Email</label>
        <Input
          data-testid="demo-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="h-11 rounded-md border-[#E8E6DF] mb-4"
        />
        <label className="text-xs uppercase tracking-[0.2em] font-semibold text-[#8B9891] block mb-2">Password</label>
        <Input
          data-testid="demo-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="h-11 rounded-md border-[#E8E6DF] mb-6"
          autoFocus
        />
        <Button
          data-testid="demo-submit-btn"
          type="submit"
          disabled={busy || !password}
          className="w-full h-11 rounded-md bg-[#971a8c] hover:bg-[#7d1574] text-white"
        >
          {busy ? "Signing in…" : "Enter demo"}
        </Button>

        <button
          type="button"
          onClick={() => nav("/")}
          className="mt-4 w-full text-sm text-[#5D6D63] hover:text-[#1C2321]"
        >
          ← Back to sign-in
        </button>
      </form>
    </div>
  );
}
